<div class="nova-font-style">
  <form novalidate [formGroup]="form" *ngIf="loadPage" id="scheduleDetails" class="form-control">
    <div id="scheduleInfo">
      <div>
        <div *ngIf="isCreate">
          <h2>Create New Pay Schedule</h2>
          <p>{{config.CreateInstructions}} </p>
        </div>
        <div *ngIf="isEdit">
          <h2>Edit Pay schedule</h2>
          <h3>Instructions</h3>
          <p class="justify">
            {{config.EditAlreadyExisting}}
          </p>
        </div>
        <div *ngIf="isContinue">
          <h2>{{config.ContinueLastYear}}</h2>
          <h3>Instructions</h3>
          <p class="justify">
            {{config.QuickContiniue}}
          </p>
        </div>
      </div>
      <div class="stroke-separator"></div>
      <h3 id="sInfo">Schedule Information</h3>
      <table class="keyValuePairs" id="sInfoTable" aria-hidden="true">
        <tr *ngIf="form.controls.fiscalYear as fyear">
          <th scope="row">Fiscal Year<span class="k-required">*</span>:</th>
          <td *ngIf="isCreate" (change)="fiscalYearChange()" class="hide-radio">
            <input type="radio" formControlName="fiscalYear" name="fiscalYear" [(ngModel)]="yr" [value]="cfy"
              class="k-radio" id="cfy{{cfy}}">
            <label class="k-radio-label" for="cfy{{cfy}}"> Current ({{cfy}})</label>

            <input type="radio" formControlName="fiscalYear" name="fiscalYear" [(ngModel)]="yr" [value]="nfy"
              class="k-radio" id="nfy{{nfy}}" style="margin-left: 1em;" checked>
            <label class="k-radio-label" for="nfy{{nfy}}"> Next ({{nfy}})</label>
            <div class="input-validation" *ngIf="isCreate && form.dirty && fyear && !fyear.value">
              <span class="validationError">{{config.FYSelectionError}}</span>
            </div>
          </td>
          <td *ngIf="isEdit || isContinue">
            <span class="editPadding">{{fyear.value}}</span>
          </td>
        </tr>
        <tr *ngIf="form.controls.name as schedulename">
          <th scope="row">Schedule Name <span class="k-required">*</span>:</th>
          <td>
            <input kendoTextBox class="name-style" placeholder="Schedule Name" id="schedule-name"
              (change)="onNameChange(schedulename.value)" formControlName="name" />
            <div class="input-validation" *ngIf="(schedulename.touched || schedulename.dirty) && schedulename.errors">
              <span class="validationError" *ngIf="schedulename.errors.minlength">{{config.MinCharName}}</span>
              <span class="validationError" *ngIf="schedulename.errors.maxlength">{{config.MaxCharName}}</span>
              <span class="validationError" *ngIf="schedulename.errors.required">{{config.EmptyName}}</span>
              <span class="validationError" *ngIf="schedulename.errors.nameExists">{{config.NameExists}}</span>
            </div>
          </td>
        </tr>
        <!-- HIDE EMPLOYER PAYROLL SCEDULE ID FOR FUTURE USE -->
        <div *ngIf="hideEmpScheduleSection">
          <tr *ngIf="form.controls.employerScheduleId as employerPayScheduleId">
            <th scope="row">Employer Payroll Schedule ID(Optional):</th>
            <td>
              <span *ngIf="isEmpScheduleId; else editEmpId">
                {{employerPayScheduleId.value}}
              </span>
              <ng-template #editEmpId>
                <input kendoTextBox class="name-style" placeholder="Schedule ID" id="schedule-id"
                  formControlName="employerScheduleId" (change)="onEmpIdChange(employerPayScheduleId.value)" />
                <div class="input-validation"
                  *ngIf="(employerPayScheduleId.touched || employerPayScheduleId.dirty) && employerPayScheduleId.errors">
                  <span class="validationError"
                    *ngIf="employerPayScheduleId.errors.maxlength; else invalidString">{{config.MaxEmpIdLength}}</span>
                  <span class="validationError"
                    *ngIf="employerPayScheduleId.errors.empScheduleIdExists">{{config.EmpIdExists}}</span>
                  <ng-template #invalidString>
                    <span class="validationError"
                      *ngIf="employerPayScheduleId.hasError('invalidAlphaNumeric')">{{config.EmpIdAlNum}}</span>
                  </ng-template>
                </div>
              </ng-template>
            </td>
          </tr>
        </div>
        <tr *ngIf="isEdit && form.controls.selectedScheduleId as schedId">
          <th scope="row">Payroll Schedule ID:</th>
          <td><span class="editPadding">{{schedId.value}}</span></td>
        </tr>
        <tr>
          <th scope="row">Location(s)<span class="k-required">*</span>:</th>
          <td>
            <div class="div-td-style">
              <div formArrayName="locations">
                <ul class="noBullets" id="location-checks">
                  <li class="padding-10"><span class="bold org-name text-red">{{orgName}}</span></li>
                  <li *ngFor="let item of form.controls.locations['controls'];let i = index" class="list-checkbox">
                    <div formGroupName="{{i}}" class="chkbx-padding">
                      <input type="checkbox" id="idi{{i}}" class="k-checkbox" formControlName="checked"
                        value="item.value.checked" [checked]="item.value.checked"
                        (change)="$event.target.checked ? item.value.checked = true : item.value.checked = false" />
                      <label class="k-checkbox-label" for="idi{{i}}">{{item.value.text}}</label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="input-validation" *ngIf="form.controls.locations.dirty && form.controls.locations.errors">
              <span class="validationError" *ngIf="form.controls.locations.errors.locNotChecked"
                id="location-error">{{config.MinLocation}}</span>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="system-th">System(s)<span class="k-required">*</span>:</th>
          <td>
            <div class="div-td-style sys-style">
              <div formArrayName="systems">
                <ul class="noBullets" id="system-checks">
                  <li *ngFor="let item of form.controls.systems['controls'];let j = index" class="list-checkbox">
                    <div formGroupName="{{j}}" class="chkbx-padding">
                      <input type="checkbox" class="k-checkbox" id="idj{{j}}" formControlName="checked"
                        value="item.value.checked" [checked]="item.value.checked"
                        (change)="$event.target.checked ? item.value.checked = true : item.value.checked = false" />
                      <label class="k-checkbox-label" for="idj{{j}}">{{item.value.text}}</label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="input-validation" *ngIf="form.controls.systems.dirty && form.controls.systems.errors">
              <span class="validationError" *ngIf="form.controls.systems.errors.systemNotChecked"
                id="system-error">{{config.MinSystem}}</span>
            </div>
          </td>
        </tr>

        <tr *ngIf="isCreate || isContinue">
          <th scope="row">Pay Frequency<span class="k-required">*</span>:</th>
          <td>
            <kendo-dropdownlist [data]="payFrequencyList" [(ngModel)]="payFrequency" [defaultItem]="defaultPF"
              [ngModelOptions]="{standalone: true}" id="payFrequency" (selectionChange)="selectionChange($event)"
              [textField]="'description'" [valueField]="'id'" formControlName="payFrequency">
            </kendo-dropdownlist>
            <div class="input-validation" *ngIf="form.controls.payFrequency.dirty">
              <span class="validationError" *ngIf="form.controls.payFrequency.errors || payFrequency ===
              defaultPF">{{config.SelectFrequency}}</span>
            </div>
          </td>
        </tr>

        <tr *ngIf="isEdit">
          <th scope="row">Created:</th>
          <td><span class="editPadding">{{createdDetails}}</span></td>
        </tr>

        <tr *ngIf="isEdit && modifiedDetails">
          <th scope="row">Modified:</th>
          <td><span class="editPadding">{{modifiedDetails}}</span></td>
        </tr>

        <tr *ngIf="isEdit">
          <th scope="row">Frequency:</th>
          <td><span class="editPadding">{{schedule?.selectedPayFrequencyText}}</span></td>
        </tr>

        <tr *ngIf="form.controls.totalPays as tp">
          <th scope="row">Total Annual Pays<span class="k-required">*</span>:</th>
          <td *ngIf="isCreate || isContinue">
            <kendo-dropdownlist [data]="totalPaysList" [(ngModel)]="totalPays" [defaultItem]="defaultTP" required
              [ngModelOptions]="{standalone: true}" id="totalPays" value="{{isCreate ? defaultTP : totalPays}}"
              formControlName="totalPays">
            </kendo-dropdownlist>
            <div class="input-validation" *ngIf="tp.dirty">
              <span class="validationError"
                *ngIf="tp.errors || tp.value === defaultTP">{{config.SelectFrequency}}</span>
            </div>
          </td>

          <td *ngIf="isEdit"><span class="editPadding">{{tp.value}}</span></td>
        </tr>

        <tr *ngIf="isEdit && form.controls.NonContr as ncpays">
          <th scope="row">Non-Contributory Pays:</th>
          <td><span class="editPadding">{{ncpays.value}}</span></td>
        </tr>

        <tr *ngIf="form.controls.contributoryCount as cCControl">
          <th scope="row">Contributory Pays<span class="k-required">*</span>:</th>
          <td>
            <kendo-numerictextbox [min]="1" [max]="53" [spinners]="false" id="contributoryPays" [format]="'n'" required
              (valueChange)="isEdit? nonContrib(cCControl.value):cCControl.value" formControlName="contributoryCount">
            </kendo-numerictextbox>
            <div class="input-validation"
              *ngIf="(cCControl.dirty ||form.controls.payScheduleEntrys.dirty) && cCControl.errors">
              <span class="validationError" id="contributoryPayError"
                *ngIf="cCControl.errors.totalPayComparison">{{config.ContPayLTTotalPay}}</span>
              <span class="validationError" id="lessContributoryPayError"
                *ngIf="cCControl.errors.checkBoxComparison">{{config.ContCountEQContFlag}}</span>
            </div>
          </td>
        </tr>

        <tr *ngIf="(isCreate || isContinue) && form.controls.initialPayPeriodEndDate as iPPED">
          <th scope="row">Initial Pay Period End Date<span class="k-required">*</span>:</th>
          <td>
            <kendo-datepicker formControlName="initialPayPeriodEndDate" [format]="'MM/dd/yyyy'" [value]="ipped"
              [min]="min" [max]="max" #PPEDate id="PPEDate" (valueChange)="onValueChange($event)"
              (blur)="ppeDatePicker.toggle(false)">
              <ng-template kendoCalendarMonthCellTemplate let-date>
                <span [class.disabled]="isDateDisabled(date)">{{date.getDate()}}</span>
              </ng-template>
            </kendo-datepicker>
            <div class="input-validation" *ngIf="((iPPED.touched || iPPED.dirty) && iPPED.errors)">
              <span class="validationError" *ngIf="iPPED.errors.ppedNotInFY">{{config.PPEDFY}}</span>
              <span class="validationError" *ngIf="iPPED.errors.notInPFreq">{{config.InvalidDate}}</span>
            </div>
          </td>
          <td *ngIf="ppedPaydate()">
            <span class="k-icon k-i-warning link-icon text-warning"></span> {{config.PPEDAfterPD}}
          </td>
        </tr>

        <tr *ngIf="(isCreate || isContinue) && form.controls.initialPayDate as iPD">
          <th scope="row">Initial Pay Date<span class="k-required">*</span>:</th>
          <td>
            <kendo-datepicker formControlName="initialPayDate" [format]="'MM/dd/yyyy'" [value]="ipd" [min]="min"
              [max]="max" id="initialPayDate">
            </kendo-datepicker>
            <div class="input-validation" *ngIf="(iPD.touched || iPD.dirty) && iPD.errors && iPD.errors.pdNotInFY">
              <span class="validationError" id="payDateError">{{config.PayDateinFY}}</span>
            </div>
            <div class="input-validation"
              *ngIf="(iPD.touched || iPD.dirty) && iPD.errors && iPD.errors.pdGreater32Days">
              <span class="validationError" id="payDateError">{{config.PDGreater32Days}}</span>
            </div>
          </td>
        </tr>

        <tr *ngIf="form.controls.comments as cmnts">
          <th scope="row">Comments (optional):</th>
          <td><textarea class="k-textarea text-area" formControlName="comments"> </textarea>
            <div class="input-validation" *ngIf="cmnts.errors && (cmnts.touched || cmnts.dirty)">
              <span class="validationError">{{config.MinCommentLength}}</span>
            </div>
          </td>
        </tr>

        <tr *ngIf="generateBtnErrorMsg">
          <td colspan="2">
            <div class="input-validation">
              <span class="validationError">{{generateBtnErrorMsg}}</span>
            </div>
          </td>
        </tr>

        <tr *ngIf="!isEdit && form.controls" id="formBtn" class="align-right">
          <th></th>
          <td colspan="2">
            <div class="btn-div">
              <button id="generate-button" class="k-button background-red text-white" [disabled]="form.invalid || payFrequency === defaultPF || totalPays === defaultTP ||
                !form.controls.contributoryCount.value" (click)="generate(form.value,form.valid)">Generate</button>
              <button id="cancel-generate" type="button" class="k-button background-red text-white" *ngIf=" !generated"
                (click)="cancel('cancel')">Cancel</button>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div id="scrollToEntries">
      <div *ngIf="generated" id="scheduleEntries">
        <div class="stroke-separator"></div>
        <div class="totals-table">
          <h3 id="scheduleHeader">Schedule Entries</h3>
          <div class="right-margin-5">
            <table aria-hidden="true">
              <thead>
                <tr>
                  <th scope="col" class="align-id color-white">#</th>
                  <th scope="col" class="align-date color-white">PPED </th>
                  <th scope="col" class="align-date color-white">Pay Date</th>
                  <th scope="col" class="align-center color-white" id="cont-th" kendoTooltip>
                    <div title="Select all">
                      <input type="checkbox" [checked]="allChecked" class="k-checkbox"
                        (change)="unCheckAll(!allChecked)" id="check-all" />
                      <label class="k-checkbox-label text-white" for="check-all">Contributory</label>
                    </div>
                  </th>
                  <th scope="col" class="align-text color-white" class="remark">Remarks</th>
                  <th scope="col" class="align-text color-white" id="misc-td"></th>
                </tr>
              </thead>
              <tbody formArrayName="payScheduleEntrys" class="kdate-picker">
                <tr id="schedule-entry-records" formGroupName="{{row_no}}"
                  *ngFor="let item of form.controls.payScheduleEntrys['controls']; let row_no = index;">
                  <td class="align-id">
                    {{row_no + 1}}
                  </td>
                  <td class="align-date">
                    <kendo-datepicker id="kendoPPED" [format]="'MM/dd/yyyy'" [(value)]="item.value.payPeriodEndDate"
                      [disabled]="item.value.isLocked" (valueChange)="onDateChange(item.value,'PPED', row_no)"
                      formControlName="payPeriodEndDate" [min]="min" [max]="max">
                      <ng-template kendoCalendarMonthCellTemplate let-date>
                        <span [ngClass]="isEnabled(date)">
                          {{date.getDate()}}
                        </span>
                      </ng-template>
                    </kendo-datepicker>
                  </td>
                  <td class="align-date">
                    <kendo-datepicker [format]="'MM/dd/yyyy'" [(value)]="item.value.payDate"
                      [disabled]="item.value.isLocked" (valueChange)="onDateChange(item.value,'PayDate', row_no)"
                      formControlName="payDate" [min]="min" [max]="maxPaydate">
                      <ng-template kendoCalendarMonthCellTemplate let-date>
                        <span [ngClass]="isEnabled(date)">{{date.getDate()}}</span>
                      </ng-template>
                    </kendo-datepicker>
                  </td>
                  <td class="checkbox-style" id="contribution-chk">
                    <input type="checkbox" class="k-checkbox" formControlName="isContributory"
                      (change)="countCheckBoxes()" id="cont{{row_no}}" />
                    <label class="k-checkbox-label" for="cont{{row_no}}"></label>
                  </td>
                  <td>
                    <input kendoTextBox formControlName="remarks" class="remark" [maxlength]="maxLengthRemarks" />
                  </td>
                  <td>
                    <div *ngIf="item.dirty && item.controls.payPeriodEndDate.invalid">
                      <span class="k-icon k-i-error text-red"></span>Invalid PPED
                    </div>
                    <div *ngIf="item.dirty && item.controls.payDate.invalid">
                      <span class="k-icon k-i-error text-red"></span>Invalid Pay Date
                    </div>
                    <div *ngIf="item.controls.pdValid.invalid">
                      <span class="k-icon k-i-error text-red" title="Pay Date is greater than 32 of PPED"></span>PPED
                      and PD diff is greater than 32d
                    </div>
                    <div
                      *ngIf="item.controls.pdValid.valid && item.controls.isHolidayOrWeekend.value && item.controls.holidayOrWeekendName.value"
                      id="msgHolidayContainer">
                      <span class="k-icon k-i-warning link-icon text-warning"></span>
                      {{item.value.holidayOrWeekendName}}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td *ngIf="payScheduleEntrys === null">{{config.NoScheduleEntry}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="form.controls.contributoryCount as ccCount" id="mis-match-contr" class="top-padding-20">
            <div *ngIf="ccCount.errors?.checkBoxComparison" id="contributoryError">
              <div class="contributoryCount">Contributory pays entered: {{ccCount.value}}</div>
              <div class="contributoryCount">
                Contributory pays selected:{{checkedBx}}
                <span id="reviewContributory">
                  <span class="k-icon k-i-error text-red"></span>{{config.ReviewCont}}
                </span>
              </div>
            </div>
          </div>
          <div *ngIf="submitBtnErrorMessage" class="top-padding-20 input-validation">
            <span class="validationError">{{submitBtnErrorMessage}}</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="generated" id="schedule-buttons" class="top-padding-20 align-right">
      <button class="k-button k-primary background-red" id="create-button" *ngIf="isCreate" [disabled]="!form.valid"
        (click)="saveScheduleData(form.value,form.valid,'Create')">Submit</button>
      <button class="k-button k-primary background-red" id="edit-button" *ngIf="isEdit" [disabled]="!form.valid"
        (click)="saveEditSchedule(form.value,form.valid)">Submit</button>
      <button class="k-button k-primary background-red" id="continue-button" *ngIf="isContinue" [disabled]="!form.valid"
        (click)="saveNewSchedule(form.value,form.valid,'Continue')">Submit</button>
      <button class="k-button background-red text-white" type="button" id="cancel-button"
        (click)="cancel('cancel')">Cancel</button>
    </div>

    <kendo-dialog title="Please confirm" class="kdialog-change app-dialog" *ngIf="opened" [minWidth]="250"
      (close)="closeConfirm('no')" id="pleaseConfirmDialog">
      <p class="important">All unsaved changes will be lost. Continue?</p>
      <kendo-dialog-actions>
        <button kendoButton class="noBtn" (click)="closeConfirm('no')" primary="true">No</button>
        <button kendoButton type="button" (click)="closeConfirm('yes')" primary="true">Yes</button>
      </kendo-dialog-actions>
    </kendo-dialog>

    <kendo-dialog title="Irregular PayCount" *ngIf="openSchedule" id="irregularDialog" [width]="450" [minWidth]="250"
      (close)="openSchedule=false" class="app-dialog">
      <p class="justify">{{schedulemsg}}</p>
      <kendo-dialog-actions>
        <button kendoButton class="regenBtn" (click)="openSchedule=false" primary="true">Re-generate</button>
        <button kendoButton (click)="continueGenerate()" primary="true">Ignore & Submit</button>
      </kendo-dialog-actions>
    </kendo-dialog>

    <kendo-dialog title=" " *ngIf="openChangesDialog" class="app-dialog" [width]="450" [minWidth]="250"
      (close)="openChangesDialog=false">
      <p class="justify">
        {{config.ReGenerate}}
        <span *ngIf="!requiresRegeneration">{{config.ReGenerateConfirm}}</span>
      </p>
      <ol class="change-ol">
        <li *ngFor="let item of errorlist">{{item}}</li>
      </ol>
      <kendo-dialog-actions>
        <button kendoButton *ngIf="!requiresRegeneration" class="ignoreBtn" (click)="changesDialog('Submit')"
          primary="true">Ignore &
          Submit</button>
        <button kendoButton (click)="changesDialog('Regenerate')" primary="true"
          id="regenerate-schedule">Re-generate</button>
      </kendo-dialog-actions>
    </kendo-dialog>
    <br class="scrollDown" />
  </form>
</div>
<app-notification-loading></app-notification-loading>
